import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import Axios from "axios";
import utils from "../utils";
import './assets/glable.css'
import qs from "qs";
import Clipboard from "clipboard/dist/clipboard";

// ========== 加密货币图标库 ==========
import IconCrypto from "vue-cryptocurrency-icons";
Vue.use(IconCrypto);
// =====================================

Vue.use(Vant);
Vue.prototype.$qs = qs;
Vue.prototype.$axios = Axios;
Vue.prototype.Clipboard = Clipboard;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
